import React from "react"

class ChartTypesDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.length) {
      return(
        <ul style={{ margin: 0, padding: 0 }}>
          {
            this.props.data.map((detail) => {
              return(
                <li key={detail.chart_name}>{detail.chart_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</li>
              )
            })
          }
        </ul>
      )
    } else {
      return null;
    }
  }

};

export default ChartTypesDataType